import { render } from "./InfoModal.vue?vue&type=template&id=1969ad3f&ts=true"
import script from "./InfoModal.vue?vue&type=script&lang=ts"
export * from "./InfoModal.vue?vue&type=script&lang=ts"

import "./InfoModal.vue?vue&type=style&index=0&id=1969ad3f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__